<template>
    <div>
        <Head title="Contact" />
        <!-- Start Hero -->
        <section class="relative table w-full pt-20 lg:pt-24 pb-10 bg-gray-50 dark:bg-slate-800">
            <div class="container">
                <div class="grid grid-cols-1 text-center mt-10">
                    <h3 class="text-3xl leading-normal font-semibold">{{ user.first_name }} {{ user.last_name }}</h3>
                </div><!--end grid-->
                <div class="user___details flex pt-3 justify-center text-center">

                </div>
            </div><!--end container-->
        </section><!--end section-->
        <div class="relative">
            <div class="shape absolute right-0 sm:-bottom-px -bottom-[2px] left-0 overflow-hidden z-1 text-white dark:text-slate-900">
                <svg class="w-full h-auto" viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                </svg>
            </div>
        </div>
        <!-- End Hero -->

        <!-- Start Section-->
        <section class="relative md:py-12">
            <div class="container flex justify-center items-center">
                <div class="user___details flex justify-center text-center" v-html="user.details" />
            </div><!--end container-->
        </section><!--end section-->
        <section class="relative md:py-3 mb-20">
            <div class="container pb-5">
                <div class="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-[30px] event___types">
                    <div v-for="event_type in event_types" :key="event_type.id" class="et__ p-6 transition duration-500 mt-6 shadow shadow-gray-100 dark:shadow-gray-800 cursor-pointer" @click="goToEventType(event_type.link)">
                        <div class="flex">
                            <div class="flex w-6 h-6 event__color rounded-full " :style="{'background-color': event_type.color}"></div>
                            <div class="flex title h5 text-lg font-bold pl-3">{{ event_type.name }}</div>
                        </div>

                        <div class="e__time pt-3 flex items-center justify-start gap-2">
                            <icon name="clock" class="w-4 h-4" />
                            <div class="__time">{{ event_type.duration.replace('_',' ') }}</div>
                        </div>

                        <div class="content mt-3">
                            <p class=" mt-2">{{ event_type.details.length < 61 ? strippedContent(event_type.details) : strippedContent(event_type.details).substring(0, 61) + "..." }}</p>
                        </div>
                        <div class="flex pt-5 justify-between items-center">
                            <div class="bar_highlight h-8 flex items-center justify-start"><icon name="bar-highlight" class="h-1" /></div>
                            <div class="arrow flex items-center justify-start h-8">Read More <icon name="cheveron-right" class="w-5 h-5" /> </div>
                        </div>
                    </div>
                </div><!--end grid-->
            </div><!--end container-->
        </section>
        <!-- End Section-->

    </div>
</template>
<script>
import Layout from '@/Shared/Landing/Layout'
import Icon from '@/Shared/Icon'
import { Head } from '@inertiajs/inertia-vue3'
import sanitizeHtml from "sanitize-html";
export default {
    layout: Layout,
    components: {
        Icon,
        Head,
    },
    props: {
        user: Object,
        event_types: Object,
    },
    data() {
        return {
            page: null
        }
    },
    methods:{
        sanitizeHtml : sanitizeHtml,
        strippedContent(html) {
            let regex = /(<([^>]+)>)/ig;
            return html.replace(regex, "");
        },
        goToEventType(link){
            window.location.href = this.route('event_type.schedule', {username: this.user.username, event_type: link})
        },
    },
    created() {
        console.log(this.event_types)
    }
}
</script>
